import arrayMutators from 'final-form-arrays'
import { noop } from 'lodash'
import React, { ReactElement, useEffect, useState } from 'react'
import { Form as FinalForm } from 'react-final-form'

import Checkbox from '../Checkbox'
import { FieldPrefix } from '../Field'
import FormStateWindow from '../FormStateWindow'
import FormGetter from './FormGetter'
import { TForm } from './types'
import withFocusOnError from './withFocusOnError'

const Form = (props: TForm): React.ReactElement => {
  const {
    name,
    children = null,
    setForm = noop,
    initialValues = {},
    onSubmit = noop,
    showFormStateWindow = false,
    setShowFormStateWindow,
    showFormStateWindowCheckbox,
    formStateWindowProps,
    mutators = {},
    decorators = [],
    onlyMountWhenValuesAreSet,
    ...rest
  } = props

  const showFormStateWindowRecoil = false // useRecoilValue(showFormStateWindowState)

  const [showFormStateWindowInternal, setShowFormStateWindowInternal] =
    useState(showFormStateWindow)

  useEffect(
    () => setShowFormStateWindowInternal(showFormStateWindow),
    [showFormStateWindow],
  )

  // Update external value
  useEffect(() => {
    if (
      setShowFormStateWindow &&
      showFormStateWindowInternal !== showFormStateWindow
    ) {
      setShowFormStateWindow(showFormStateWindowInternal)
    }
  }, [showFormStateWindowInternal])

  const isLocal = /localhost/.test(window.location.href)

  return (
    <FieldPrefix overwritePrefix prefix={undefined}>
      <FinalForm
        mutators={{
          ...mutators,
          ...arrayMutators,
        }}
        decorators={decorators}
        {...rest}
        onSubmit={onSubmit}
      >
        {(formProps): ReactElement => (
          <FormGetter
            {...formProps}
            setForm={setForm}
            initialValues={initialValues}
            onlyMountWhenValuesAreSet={onlyMountWhenValuesAreSet}
          >
            {isLocal && showFormStateWindowCheckbox && (
              <Checkbox
                value={showFormStateWindowInternal}
                onChange={(): void => {
                  setShowFormStateWindowInternal(!showFormStateWindowInternal)
                }}
              >
                Show FormStateWindow
              </Checkbox>
            )}
            {isLocal &&
              (showFormStateWindowRecoil || showFormStateWindowInternal) && (
                <FormStateWindow {...formStateWindowProps} />
              )}
            {Array.isArray(children)
              ? React.Children.map(children, (child) =>
                  React.cloneElement(child as React.ReactElement, {
                    ...formProps,
                  }),
                )
              : React.cloneElement(children as React.ReactElement, {
                  ...formProps,
                })}
          </FormGetter>
        )}
      </FinalForm>
    </FieldPrefix>
  )
}

export default withFocusOnError(Form)

export { FormSpy } from 'react-final-form'

export { default as FormContext } from './FormContext'

export { default as FormContextProvider } from './FormContextProvider'

export { default as useFormContext } from './useFormContext'

export { default as FormState } from './FormState'

export { default as useForm } from './useForm'

export { default as OnChange } from './OnChange'

export { default as SubmitButton } from './SubmitButton'
